import React, { useState } from "react";
import { Alert, Button } from "antd";
import dayjs from "dayjs";

interface TrialBannerProps {
  trialEndsAt?: string | null;
  planType?: string;
  cancelledAt?: string | null;
}

export const TrialBanner: React.FC<TrialBannerProps> = ({
  trialEndsAt,
  cancelledAt,
}) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || cancelledAt) return null;

  if (trialEndsAt) {
    const daysLeft = dayjs(trialEndsAt).diff(dayjs(), "day");

    if (daysLeft < 0) {
      return (
        <Alert
          type="error"
          showIcon
          banner
          message="Your free trial has expired."
          description={
            <>
              Upgrade to continue using ARRUK.{" "}
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  window.location.href = "/settings?tab=billing";
                }}
              >
                Upgrade Now
              </Button>
            </>
          }
          closable
          onClose={() => setDismissed(true)}
          style={{ marginBottom: 16 }}
        />
      );
    }

    if (daysLeft <= 14) {
      return (
        <Alert
          type="warning"
          showIcon
          banner
          message={`${daysLeft} day${daysLeft !== 1 ? "s" : ""} left in your free trial.`}
          description={
            <>
              Upgrade to keep access to all features.{" "}
              <Button
                size="small"
                onClick={() => {
                  window.location.href = "/settings?tab=billing";
                }}
              >
                Upgrade Now
              </Button>
            </>
          }
          closable
          onClose={() => setDismissed(true)}
          style={{ marginBottom: 16 }}
        />
      );
    }
  }

  return null;
};
